module.exports = __webpack_public_path__ + "static/img/徐小红.ec3d25a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teacher/徐小红.jpg
// module id = 2YG1
// module chunks = 138